export const CAMPAIGN_LIST_KEY = 'CAMPAIGN_LIST_KEY';
export const CAMPAIGN_ONE_KEY = 'CAMPAIGN_ONE_KEY';

export const CAMPAIGN_PHASE_LIST_KEY = 'CAMPAIGN_PHASE_LIST_KEY';
export const CAMPAIGN_PHASE_ONE_KEY = 'CAMPAIGN_PHASE_ONE_KEY';

export const CAMPAIGN_PRICE_SETTINGS_KEY = 'CAMPAIGN_PRICE_SETTINGS_KEY';

// Analytics
export const CAMPAIGN_CLICKS_SUMMARY_KEY = 'CAMPAIGN_CLICKS_SUMMARY_KEY';
export const CAMPAIGN_IMPRESSION_SUMMARY_KEY = 'CAMPAIGN_IMPRESSION_SUMMARY_KEY';
export const CAMPAIGN_CLICKS_HISTOGRAM_KEY = 'CAMPAIGN_CLICKS_HISTOGRAM_KEY';
export const CAMPAIGN_IMPRESSION_HISTOGRAM_KEY = 'CAMPAIGN_IMPRESSION_HISTOGRAM_KEY';
export const CAMPAIGN_TOP_CLICKS_KEY = 'CAMPAIGN_TOP_CLICKS_KEY';
export const CAMPAIGN_TOP_IMPRESSION_KEY = 'CAMPAIGN_TOP_IMPRESSION_KEY';
export const CAMPAIGN_EMAIL_SUMMARY_KEY = 'CAMPAIGN_EMAIL_SUMMARY_KEY';
export const CAMPAIGN_EMAIL_SUMMARY_PHASE_KEY = 'CAMPAIGN_EMAIL_SUMMARY_PHASE_KEY';
export const CAMPAIGN_EMAIL_HISTOGRAM_EVENT_KEY = 'CAMPAIGN_EMAIL_HISTOGRAM_EVENT_KEY';
